
import router from '@/router';
import store from '@/store';

export default {
  name: 'EazyHeading',

  props: {
    pageName: {
      type: String,
      default: '',
    },
    preventRedirection: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },

  data(): Record<string, unknown> {
    return {
      dashboardPaths: ['/assessor-tasks', '/client-tasks'],
      favouritesPath: '/favorites',
    };
  },

  computed: {
    userRole(): string {
      return store.state.userRole;
    },
    flowType(): string {
      return localStorage.getItem('flowType');
    },
    isAssessorPlus(): boolean {
      return localStorage.getItem('roleType') === 'assessorPlus';
    },
    isFreeClient(): boolean {
      return localStorage.getItem('isFreeClient') === 'true';
    },
  },

  methods: {
    redirectToHome(): void {
      if (store.state.userRole === 'assessor' && !store.state.accountVerified) return;

      if (this.preventRedirection || this.dashboardPaths.includes(this.$route.path)) return;
      router.push({ path: `/${this.userRole}-tasks` });
    },
    redirectToAssessorOnboardingClient(): void {
      router.push('/assessor-onboarding-client');
    },
  },
};
